import { FC } from "react";
import { Box, Typography } from "@material-ui/core";

import { Button, Modal } from "components";
import { ALL_ACCESS_MEMBERSHIP_URL } from "constants/index";

interface AAIVerificationModalProps {
  onClose: () => void;
}

const AAIVerificationModal: FC<AAIVerificationModalProps> = ({ onClose }) => {
  return (
    <Modal open title="Become An All Access Investor" onClose={onClose}>
      <Typography component="div" gutterBottom>
        Only buyers who have previously submitted offers on this listing or{" "}
        <strong>All Access Investors</strong> can place final offers. Become an
        All Access Investor today to bid on this listing before time runs out!
      </Typography>
      <a
        href={ALL_ACCESS_MEMBERSHIP_URL}
        style={{ textDecoration: "none", color: "inherit" }}
        target="blank"
      >
        <Box mt={4} mb={2}>
          <Button
            customColor="green"
            size="large"
            variant="contained"
            fullWidth
          >
            Become An All Access Investor
          </Button>
        </Box>
      </a>
      <Box mt={2}>
        <Button
          customColor="gray"
          size="small"
          variant="text"
          fullWidth
          onClick={onClose}
        >
          No thanks
        </Button>
      </Box>
    </Modal>
  );
};

export default AAIVerificationModal;
